import { get, includes } from 'lodash';
import { takeLatest, select } from 'redux-saga/effects';

import storageService from '@lib/services/storageService';
import { selectCurrentUser } from '@lib/selectors';
import { UserBase } from '@lib/resources/types';
import { getWaitingRoomFacilityKeyByUserId } from 'storage/keys';

import {
  ON_SOCKET_WAITING_ROOM_PATIENT_CREATE,
  ON_SOCKET_WAITING_ROOM_PATIENT_STATUS_UPDATE,
  ON_SOCKET_WAITING_ROOM_PATIENT_UPDATE,
} from 'containers/App/constants';

import sagaRelayInvalidateData from './sagaRelayInvalidateData';

function* sagaInvalidateStore() {
  yield sagaRelayInvalidateData('WaitingRoomPatient');
}

function* sagaCheckFacility(action: any) {
  const currentUser: UserBase = yield select(selectCurrentUser);
  const waitingRoomFacilityKeyByUserId = getWaitingRoomFacilityKeyByUserId(get(currentUser, 'id', ''));
  const currentFacilityOnBoard = storageService.get(waitingRoomFacilityKeyByUserId);

  // trigger the refetch if the socket is from a facility you have selected on your board.
  if (includes(currentFacilityOnBoard, get(action.data, 'facility', ''))) {
    yield sagaInvalidateStore();
  }
}

export default function* sagaWatchersWaitingRoomPatient() {
  // Invalidate data on Relay store and refetch queries
  yield takeLatest(ON_SOCKET_WAITING_ROOM_PATIENT_STATUS_UPDATE, sagaCheckFacility);
  yield takeLatest(ON_SOCKET_WAITING_ROOM_PATIENT_CREATE, sagaCheckFacility);
  yield takeLatest(ON_SOCKET_WAITING_ROOM_PATIENT_UPDATE, sagaCheckFacility);
}
